function initCheckoutCart() {
    var qtyUpBtns = document.querySelectorAll('.js-qty-up');

    for (var i = 0; i < qtyUpBtns.length; i++) {
        qtyUpBtns[i].onclick = raiseProductQuantity;
    }

    var qtyDownBtns = document.querySelectorAll('.js-qty-down');

    for (var i = 0; i < qtyDownBtns.length; i++) {
        qtyDownBtns[i].onclick = lowerProductQuantity;
    }

    var removeProductBtns = document.querySelectorAll('.js-remove-item');

    for (var i = 0; i < removeProductBtns.length; i++) {
        removeProductBtns[i].onclick = removeProductFromCart;
    }

    var changeProductTxtBoxes = document.querySelectorAll('.js-change-qty');

    for (var i = 0; i < changeProductTxtBoxes.length; i++) {
        changeProductTxtBoxes[i].onchange = changeProductQuantity;
    }
}

function removeProductFromCart() {
    event.preventDefault();

    var el = this;
    var code = el.getAttribute('data-code');
    var shipmentId = el.getAttribute('data-shipmentId');
    var url = el.getAttribute('data-url');

    updateCartQuantity(0, code, url, shipmentId);
}

function changeProductQuantity() {
    var el = this;

    var quantity = parseInt(el.value);
    var code = el.getAttribute('data-code');
    var url = el.getAttribute('data-url');
    var shipmentId = el.getAttribute('data-shipmentid');
    var brand = el.getAttribute('data-brand');
    var price = el.getAttribute('data-price');
    var category = el.getAttribute('data-category');
    var variant = el.getAttribute('data-variant');
    var name = el.getAttribute('data-name');

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'change_quantity', ecommerce: {
            items: [{
                item_name: name, item_id: code, price: price, item_brand: brand, item_category: category, item_variant: variant, quantity: quantity
            }]
        }
    });

    updateCartQuantity(quantity, code, url, shipmentId);
}

function updateCartQuantity(quantity, code, url, shipmentId) {
    var itemsPartial = document.querySelector('#jsCartItemsPartial');

    fetch(url, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ code: code, quantity: quantity, shipmentId: shipmentId })
    })
        .then(function (res) {
            return res.text();
        })
        .then(function (html) {
            // Update cart items list
            itemsPartial.innerHTML = html;

            // Update cart summary
            var cartSummaryBlock = document.querySelector('#js-cart-summary-wrapper');
            var jsHiddenCartSummary = document.querySelector('.jsHiddenCartSummary');
            cartSummaryBlock.innerHTML = jsHiddenCartSummary.innerHTML;

            // Update cart badge
            var newCountSpan = document.querySelector('.jsHiddenCartItemsCount');
            updateMiniCartCount(newCountSpan.innerHTML);

            initCheckoutCart();
        })
        .catch(function (err) {
            console.log(err);
        });
}

function updateMiniCartCount(newCount) {
    var badge = document.querySelector('.cart-badge');
    badge.innerHTML = parseInt(newCount);
}

function raiseProductQuantity(e) {
    e.preventDefault();
    var el = this;

    var code = el.getAttribute('data-code');
    var url = el.getAttribute('data-url');
    var shipmentId = el.getAttribute('data-shipmentid');
    var brand = el.getAttribute('data-brand');
    var price = el.getAttribute('data-price');
    var category = el.getAttribute('data-category');
    var variant = el.getAttribute('data-variant');
    var name = el.getAttribute('data-name');

    var productQuantityTextBox = document.getElementById('productQuantity-' + code);

    var quantity = parseInt(productQuantityTextBox.value);
    if (isNaN(quantity)) {
        return;
    }

    quantity += 1;
    productQuantityTextBox.value = quantity;


    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'add_to_cart', ecommerce: {
            items: [{
                item_name: name, item_id: code, price: price, item_brand: brand, item_category: category, item_variant: variant, quantity: quantity
            }]
        }
    });

    updateCartQuantity(quantity, code, url, shipmentId);
}

function lowerProductQuantity(e) {
    e.preventDefault();
    var el = this;
   
    var code = el.getAttribute('data-code');
    var url = el.getAttribute('data-url');
    var shipmentId = el.getAttribute('data-shipmentid');
    var brand = el.getAttribute('data-brand');
    var price = el.getAttribute('data-price');
    var category = el.getAttribute('data-category');
    var variant = el.getAttribute('data-variant');
    var name = el.getAttribute('data-name');

    var productQuantityTextBox = document.getElementById('productQuantity-' + code);

    var quantity = parseInt(productQuantityTextBox.value);

    if (isNaN(quantity)) {
        return;
    }

    quantity -= 1;
    if (quantity < 0) {
        quantity = 0;
    }

    productQuantityTextBox.value = quantity;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'remove_from_cart', ecommerce: {
            items: [{
                item_name: name, item_id: code, price: price, item_brand: brand, item_category: category, item_variant: variant, quantity: quantity
            }]
        }
    });

    updateCartQuantity(quantity, code, url, shipmentId);
}

initCheckoutCart();